import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { H3, Input, Span, Text, Textarea } from '@/components/atoms'
import { DatePickerField, SelectField } from '@/components/molecules'
import { useClaimsRentersStepOne } from './page.claims.renters-step-one.hook'
import { FORM_PLACEHOLDER } from '@/shared/constants/forms'

export function ClaimsRentersStepOnePage() {
  const { t } = useTranslation()
  const {
    control,
    rules,
    fieldErrors,
    policyOptions,
    sanitizePhone,
    maxDateOfLoss,
  } = useClaimsRentersStepOne()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 md:hidden">
        <H3 className="text-[2rem]! text-neutral-900">
          <Span textSize="">{t('claims.renters.titleStart')}</Span>
          <br />
          <Span textSize="" className="text-indigo-base!">
            {t('claims.renters.titleHighlight')}
          </Span>
        </H3>
        <Text className="text-neutral-900">
          {t('claims.renters.description')}
        </Text>
      </div>

      <H3 className="text-[1.5rem] text-neutral-900">
        {t('claims.renters.stepOne.title')}
      </H3>

      <Controller
        control={control}
        name="policyId"
        rules={rules.policyId}
        render={({ field }) => (
          <SelectField
            id="policyId"
            label={t('claims.renters.form.policyLabel')}
            placeholder={t('claims.renters.form.policyPlaceholder')}
            options={policyOptions}
            value={field.value}
            error={fieldErrors.policyId}
            onSelect={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Controller
          control={control}
          name="dateOfLoss"
          rules={rules.dateOfLoss}
          render={({ field }) => (
            <DatePickerField
              id="dateOfLoss"
              label={t('claims.renters.form.dateOfLossLabel')}
              placeholder={FORM_PLACEHOLDER.DATE}
              value={field.value}
              maxDate={maxDateOfLoss}
              error={fieldErrors.dateOfLoss}
              onChange={field.onChange}
              onBlur={field.onBlur}
              dropdownMonthYear
              panelPosition="relative"
            />
          )}
        />

        <Controller
          control={control}
          name="phone"
          rules={rules.phone}
          render={({ field }) => (
            <Input
              id="phone"
              data-testid="renters-claim-phone-input"
              label={t('claims.renters.form.phoneLabel')}
              placeholder={FORM_PLACEHOLDER.PHONE}
              type="tel"
              inputMode="tel"
              value={field.value}
              error={fieldErrors.phone}
              onChange={(e) => field.onChange(sanitizePhone(e.target.value))}
              onBlur={field.onBlur}
            />
          )}
        />
      </div>

      <Controller
        control={control}
        name="description"
        rules={rules.description}
        render={({ field }) => (
          <Textarea
            id="description"
            data-testid="renters-claim-description-input"
            label={t('claims.renters.form.descriptionLabel')}
            placeholder={t('claims.renters.form.descriptionPlaceholder')}
            value={field.value}
            error={fieldErrors.description}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />
    </div>
  )
}
